import { render, staticRenderFns } from "./email-input.vue?vue&type=template&id=23b62eb0&scoped=true&"
import script from "./email-input.vue?vue&type=script&lang=js&"
export * from "./email-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b62eb0",
  null
  
)

export default component.exports